import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import Text from 'style-guide/Typography/Text';

const BreadcrumbItem = ({ Icon, url, label, lastElement }) => {
  const { pathname } = useLocation();
  const activeItem = pathname === url;

  return (
    <>
      {url && !activeItem ? (
        <Link to={url} className='pointer d-inline-flex align-items-center breadcrumbs-item'>
          {Icon && <Icon className='mr--4' width={16} height={16} />}
          {label}
        </Link>
      ) : (
        <span className={classNames({ 'active-item': activeItem }, 'd-inline-flex align-items-center')}>
          {Icon && <Icon className='mr--4' width={16} height={16} />}
          {label}
        </span>
      )}
      {lastElement ? <Text className='mh--8 separator'> / </Text> : null}
    </>
  );
};

export default BreadcrumbItem;
